import Modal from 'ageas-react-component-modal'
import PageTitle from 'ageas-react-component-pagetitle'

import { MainContainer } from '../../GlobalStyles'

import { MatchedEntity } from '../../@types/GetEntitiesDetails'
import { MatchedEntity as MatchedIndividualEntity } from '../../@types/PolicyHolderDetails'
import { t } from '../../i18n'
import { ModalComponent } from '../ModalComponent'
import { EntityTableSelection } from './EntityTableSelection'
import { Container } from './styles'

type SelectedEntityProps = {
  isVisible: boolean
  data: Partial<MatchedIndividualEntity[] | MatchedEntity[]> | undefined
  type?: 'entity' | 'policyHolder'
  closeAction?: () => void
}

export function SelectedEntity({
  isVisible,
  data,
  type = 'entity',
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  closeAction = () => {},
}: SelectedEntityProps) {
  return (
    <ModalComponent show={isVisible}>
      <Modal
        show={isVisible}
        hideCloseAction={false}
        closeAction={closeAction}
        content={
          <MainContainer>
            <Container>
              <PageTitle
                id="selectedEntity"
                name={t('pages.step1.selectEntityPerson')}
              />

              <EntityTableSelection
                data={data}
                type={type}
                closeAction={closeAction}
              />
            </Container>
          </MainContainer>
        }
      />
    </ModalComponent>
  )
}
